import Content from './Content';
import Footer from './Footer';
import Header from './Header';

export const PartDrawer = {
  Header,
  Content,
  Footer,
};
